import { sva } from "@agapi/ui/panda/css";

export const productRecommendationSliderStyles = sva({
  slots: ['container', 'title', 'productList', 'product'],
  base: {
    container: {
      py: 4,
      gap: 4,
    },
    title: {
      textStyle: 'h3',
      color: 'text.heading',
      mb: 5,
    },
    productList: {
      display: 'flex',
      flexDirection: 'column',
      gap: 4,
      overflow: {
        base: 'visible',
        md: 'hidden'
      }
    },
    product: {
      height: '100%',
      width: {
        base: 'calc(token(sizes.containers.3xs) * 2)',
        md: 'calc(token(sizes.containers.sm) - token(sizes.containers.2xs))'
      }
    }
  },
});